import { useEffect } from 'react';
import { COPY } from '../contracts/copyMap';

// Set document.title for the mounted route, restoring the brand default on
// unmount. This is a SPA with no prerendering, so every route ships the same
// static <title> from public/index.html unless a component overrides it.
//
// Extracted from PublicPageLayout so the sign-in surface can set a title
// WITHOUT adopting that component's editorial column layout. `/` receives 87%
// of all sessions and was inheriting the generic global title.
export default function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title || COPY.BRAND_NAME;
    return () => {
      document.title = COPY.BRAND_NAME;
    };
  }, [title]);
}
